<script>
import p000 from './icons/battery-000.svg'
import p020 from './icons/battery-020.svg'
import p040 from './icons/battery-040.svg'
import p060 from './icons/battery-060.svg'
import p080 from './icons/battery-080.svg'
import p100 from './icons/battery-100.svg'
import caution from './icons/battery-caution.svg'
import empty from './icons/battery_empty.svg'
import full from './icons/battery_full.svg'
import low from './icons/battery-low.svg'
import unknown from './icons/battery-unknown.svg'
export default
{
    name: 'mv-battery',

    props:
    {
        percent: Number,
        voltage: Number,
    },

    computed:
    {
        batteryIcon()
        {
            if (!this.percent || this.percent == null || this.percent == undefined)
                return unknown
            if (this.percent < 5)
                return empty
            if (this.percent < 15)
                return caution
            if (this.percent < 25)
                return p020
            if (this.percent < 40)
                return low
            if (this.percent < 50)
                return p040
            if (this.percent < 75)
                return p060
            if (this.percent < 90)
                return p080
            if (this.percent < 100)
                return p100
            if (this.percent == 100)
                return full
        },

        batteryText()
        {
            if (this.voltage)
                return `${this.percent}% - ${this.voltage}mV`
            else
                return '???'
        },

        percentText()
        {
            if (this.voltage)
            {
                if (this.percent || this.percent == 0)
                {
                    let num = String(this.percent)
                    if (num.length < 2) num = '0' + num
                    return `${num}%`
                }
            }
            return '??%'
        }

    },

}
</script>

<template>
<div>
    <img :src="batteryIcon" :alt="batteryText" :title="batteryText"> {{ percentText }}
</div>
</template>




// WEBPACK FOOTER //
// src/components/battery/Battery.vue